import React, { Fragment } from "react";
import { Provider } from 'react-redux';
import store from "./redux/store";
import MainPage from "./components/MainPage";
import { Helmet } from "react-helmet";

import favicon from "./assets/favicon.ico";

const App = () => (
  <Fragment>
    <Provider store={store}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Upward.careers - Find a Job. Move Upward</title>
        <link href={favicon} rel="shortcut icon" />
      </Helmet>
      <MainPage />
    </Provider>
  </Fragment>
);

export default App;
